import React, { useState } from 'react';

function StepThirteen({ formData, onNext }) {
    const [ref1Name, setRef1Name] = useState(formData.ref1Name || '');
    const [ref1Email, setRef1Email] = useState(formData.ref1Email || '');
    const [ref1Mobile, setRef1Mobile] = useState(formData.ref1Mobile || '');

    const [ref2Name, setRef2Name] = useState(formData.ref2Name || '');
    const [ref2Email, setRef2Email] = useState(formData.ref2Email || '');
    const [ref2Mobile, setRef2Mobile] = useState(formData.ref2Mobile || '');

    const [error, setError] = useState('');

    const handleContinue = () => {
        if (
            !ref1Name || !ref1Email || !ref1Mobile ||
            !ref2Name || !ref2Email || !ref2Mobile
        ) {
            setError('Please fill out all required fields for both referees.');
            return;
        }

        setError('');
        onNext({
            ref1Name,
            ref1Email,
            ref1Mobile,
            ref2Name,
            ref2Email,
            ref2Mobile,
        });
    };

    const isFormValid =
        ref1Name && ref1Email && ref1Mobile &&
        ref2Name && ref2Email && ref2Mobile;

    return (
        <div className="step-form">
            <h6 className="mb-1">References</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Please provide details of 2 references that can confirm your employment in the last 3 years.</p>

            <h6 className="mt-4">Referee 1</h6>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            value={ref1Name}
                            onChange={e => setRef1Name(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={ref1Email}
                            onChange={e => setRef1Email(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="Mobile Number"
                            value={ref1Mobile}
                            onChange={e => setRef1Mobile(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <h6 className="mt-4">Referee 2</h6>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            value={ref2Name}
                            onChange={e => setRef2Name(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={ref2Email}
                            onChange={e => setRef2Email(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="Mobile Number"
                            value={ref2Mobile}
                            onChange={e => setRef2Mobile(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepThirteen;
